<template>
  <div> 
    <div v-if='hasNews && newsLoaded' class="scroller">
      <div v-for="(newsEntry, i) in newsData"
            :class="{ 'news-entry bottom-border': i < (newsData.length - 1), 'news-entry' : i === (newsData.length - 1)  }"
            :key='i'          
            >
        <ed-span class="news-title text-data" @click="handleClick(newsEntry)">{{newsEntry.Title}}</ed-span>
        <ed-span class="news-date text-data">{{newsEntry.CreatedDateFormatted}}</ed-span>
      </div>
    </div>
    <div class="empty-holder" v-if='!newsLoaded'>
      <span class="news-loading"/> Loading News ...
   </div>
    <div class="empty-holder" v-if='!hasNews && newsLoaded'>
      <div>
        <i class="fal fa-lg fa-newspaper"/> 
        <span>
          <p class="bold">No Recent Posts</p>
          <p class="light">Platform updates and company</p>
          <p class="light">messages will appear here</p>
        </span>
      </div>
    </div>
  </div>
</template>

<script>

  import { EventBus } from '@/event-bus'
  import { initScrollbar } from '../../helpers/scrollbarHelper.js'
  export default {
    alias: 'news-wdg-cmp',
    name: 'news',

    props: { widget: Object },

    computed: {
      hasNews() {
        if (this.newsData.length > 0) return true
        else {
          return false
        }
      }
    },

    created() {
      this.api.get(this.widget.endPoint, {})
        .then(r => {
          this.newsData = r.data.Data
          this.newsLoaded = true
          this.$nextTick(() => {
            let maxH = this.newsData.length >= 3 ? 3 : this.newsData.length
            let desiredHeight = this.hasNews ? maxH : 1
            EventBus.$emit('updateWidgetHeight', {
              wId: this.widget.id,
              height: desiredHeight,
              alt: -1
            })
            if (this.newsData.length > 3) {
              this.$el.querySelector('.scroller').style.height = '190px'
              initScrollbar(this, '.scroller')
            }
          })
        })
    },

    data() {
      return {
        newsData: [],
        newsLoaded: false
      }
    },

    methods: {
      handleClick(entry) {
        this.$router.push('/i/Admin/UserNotification/GetNotificationCenter?notificationId=' + entry.AppNotificationId)
      }
    }
  }
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.news-entry {
  display: block;
  padding: 0.7rem 0rem;
  margin: 0rem 1rem 0rem 0.5rem;
}

.scroller{
  position:relative;
  overflow: hidden;
}

.news-entry:only-of-type {
  padding: 0.2rem 0rem;
}

.bottom-border{
  border-bottom-color: rgb(220, 220, 220);
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

ed-span.news-title {
  font-weight: 700;
  cursor: pointer;
  display: block
}
ed-span.news-date {
  font-style:italic;
  display: block;
}
.news-loading{
    margin-top: 25px;
    margin-left: 50px;
}
div.empty-holder {
    position: absolute;
    left: 170px;
    i.fal{
      font-size: 1.7rem;
      height: 50px;
      width: 50px;
      padding-top:20px;
      padding-left:1px;
      background-color:#f2f2f2;
      border-radius: 50%;
      display: inline-block;
      margin-right: 10px;
    }
    .fa-newspaper:before{
      position: absolute;
      top: 14px;
      left: 10px;
    }
    text-align: center;
    margin-top: 0px;
    color: #9c9c9c;
    font-size: 0.96em;
    font-weight: 600;
    span{
      text-align: left;
      display: inline-block;
      p{
        line-height: 0.4rem;
        display:block;
        &.bold{
          font-weight: 650
        }
        &.light{
          font-size: 0.8rem;
          font-weight: 200;
        }
    }
  }}

.text-data{
  font-size: 0.9rem;
  line-height: 1.2rem;
}


</style>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/News/index.vue